import React from 'react';
import ReactGoogleAutocomplete from 'react-google-autocomplete';
import { env } from '@/shared/config/env';

interface AddressAutocompleteProps {
  value: string;
  onChange: (value: string) => void;
  onPlaceSelect: (place: any) => void;
  error?: string | null;
  placeholder?: string;
  testId?: string;
}

const AddressAutocomplete: React.FC<AddressAutocompleteProps> = ({
  value,
  onChange,
  onPlaceSelect,
  error,
  placeholder = "Enter address",
  testId
}) => {
  return (
    <div>
      <ReactGoogleAutocomplete
        apiKey={env.googleApiKey}
        value={value}
        onChange={e => onChange((e.target as HTMLInputElement).value)}
        onPlaceSelected={onPlaceSelect}
        options={{
          types: ['establishment', 'geocode'],
          componentRestrictions: { country: 'fr' },
        }}
        placeholder={placeholder}
        className={`h-11 w-full rounded-lg border appearance-none px-4 py-2.5 text-sm shadow-theme-xs placeholder:text-gray-400 focus:outline-none focus:ring dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 ${error ? 'border-error-500' : 'border-gray-300'}`}
        style={{ background: 'transparent' }}
        data-testid={testId}
      />
      {error && (
        <p className="mt-1.5 text-xs text-error-500">{error}</p>
      )}
    </div>
  );
};

export default AddressAutocomplete;
